import { Injectable } from '@angular/core';
import { CanActivate, RedirectCommand, Router } from '@angular/router';

import { AccessContextService } from '../services/access-context/access-context.service';
import { TokenService } from '../services/token/token.service';
import { AuthService } from '../services/auth/auth.service';
import { CurrentUserService } from '../services/current-user/current-user.service';

/**
 * Validate if a user is logged in.
 */
@Injectable({
  providedIn: 'root',
  deps: [TokenService, Router, AccessContextService],
})
export class AuthGuard implements CanActivate {
  constructor(
    protected tokenService: TokenService,
    protected router: Router,
    private authService: AuthService,
    private currentUserService: CurrentUserService
  ) {}

  async canActivate(): Promise<boolean | RedirectCommand> {
    if (this.tokenService.getRefreshToken() === null) {
      this.authService.logout();
    }
    await this.currentUserService.loadCurrentUser();
    if (this.currentUserService.currentUser === null) {
      this.authService.clearAuthData();
      const loginPath = this.router.parseUrl('/login');
      return new RedirectCommand(loginPath, {
        skipLocationChange: true,
      });
    }
    return true;
  }
}
